module["exports"] = [
  "03# ### ####",
  "05# ### ####",
  "07# ### ####",
  "08# ### ####",
  "09# ### ####"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/vi/cell_phone/formats.js
// module id = 3696
// module chunks = 1610